import React from "react";

const Close: React.FC = () => (
<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<line x1="26.3555" y1="9.49324" x2="9.49031" y2="26.3584" stroke="white" strokeLinecap="round"/>
<path d="M26.3555 26.3584L8.7832 8.78613" stroke="white" strokeLinecap="round"/>
</svg>
);

export default Close;
